import { INTEGRATION_TYPES, typeTextMap } from '@model';
import { SectionRadioLabel } from '@model/settings/addModalConfig';
import { deepCopy } from '@utils/common';

// NOTE: please do not use this file, all configs for adding module were moved to src/model/settings/addModalConfig.js

export const addModuleConfig = {
  addTitle: 'Add New Tile',
  addNew: 'Tile Type',
  radios: [
    {
      value: 'powerbi',
      text: SectionRadioLabel.PBI,
      //   tipTitle:
      //     'Create a tile on the left pane to quickly navigate to an iFramed PowerBI dashboard',
      typeText: 'Power BI',
    },
    {
      value: 'pdf',
      text: SectionRadioLabel.PDF,
      // tipTitle: 'Create a tile on the left pane to quickly navigate to any ',
      typeText: 'PDF',
    },
    {
      value: 'image',
      text: SectionRadioLabel.Image,
      typeText: 'Image',
    },
    {
      value: 'text',
      text: SectionRadioLabel.Other,
      typeText: 'Other',
    },
    // {
    //   value: 'chart',
    //   // text: 'Visualization Widget (e.g., Gantt Chart, Waterfall Chart, etc.)',
    //   text: 'Visualization Widget (Spider Chart)',
    //   typeText: 'Widget',
    // },
    {
      value: INTEGRATION_TYPES.TEXT_CONTAINER,
      text: SectionRadioLabel.Richtext,
      typeText: 'Text',
    },
  ],
  typeTextMap,
};

const addChartWidgetRadio = (config) => {
  const newConfig = deepCopy(config);
  newConfig.radios = [
    ...newConfig.radios,
    {
      value: INTEGRATION_TYPES.CHART,
      // text: 'Visualization Widget (e.g., Gantt Chart, Waterfall Chart, etc.)',
      text: 'Visualization Widget (Spider Chart)',
      typeText: 'Chart',
    },
  ];
  return newConfig;
};

export const addModuleConfigInProjectHome = Object.assign(
  {},
  addChartWidgetRadio(Object.assign({}, addModuleConfig)),
  {
    addTitle: 'Add New Section',
    addNew: 'Section Type',
  },
);
